import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import useApi from '../../utils/useApi';

import '../../css/common-components.css';

import styles from './Disconnect.module.css';

const Disconnect = () => {
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(true);
  const [disconnectionResult, setDisconnectionResult] = useState(null); // 'success' or 'error'
  const [searchParams] = useSearchParams();

  const isPopup = searchParams.has('popup');

  const api = useApi();

  const handleDisconnectAccounts = async () => {

    setIsDisconnecting(true);

    try {
      const response = await api.post('/auth/disconnect');

      if (response.status === 200) {
        setDisconnectionResult('success');
      } else {
        console.error(`Failed to disconnect accounts. Status: ${response.status}`);
        setDisconnectionResult('error');
      }
    } catch (error) {
      console.error('Error disconnecting accounts:', error);
      setDisconnectionResult('error');
    } finally {
      setIsDisconnecting(false);
      setShowConfirmation(false);
    }
  };

  const handleReturnToHubSpot = () => {
    // Send message to parent window to close modal/iframe
    window.parent.postMessage(JSON.stringify({ action: "DONE" }), "*");
  };

  const handleCancel = () => {
    handleReturnToHubSpot();
  };

  if (!showConfirmation && disconnectionResult) {
    return (
      <div className={styles.pageWrapper}>
        <div className={styles.container}>
          {disconnectionResult === 'success' ? (
            <div className={styles.resultContainer}>
              <h2 className={styles.title}>Disconnection Successful</h2>
              <p className={styles.successMessage}>
                Your BoldSign account is now disconnected from HubSpot.
                You can no longer send or track signature requests from your HubSpot CRM. You can close this window now.
              </p>
              {isPopup && (
                <button
                  onClick={handleReturnToHubSpot}
                  className="btn-outline-primary"
                >
                  Close
                </button>
              )}
            </div>
          ) : (
            <div className={styles.resultContainer}>
              <h2 className={styles.title}>Unable to Disconnect</h2>
              <p className={styles.errorMessage}>
                We were unable to disconnect your HubSpot and BoldSign accounts. Please try again, or contact support if the issue persists. You can close this window now.
              </p>
              {isPopup && (
                <button
                  onClick={handleReturnToHubSpot}
                  className="btn-outline-primary"
                >
                  Close
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>Disconnect BoldSign?</h2>
        <p className={styles.description}>
          Are you sure you want to disconnect your BoldSign account
        </p>

        <div className={styles.warningBox}>
          <ul className={styles.warningList}>
            <li>You will no longer be able to send documents for signature from HubSpot.</li>
            <li>You can reconnect your accounts at any time.</li>
          </ul>
        </div>

        <div className={styles.buttonContainer}>
          <button
            onClick={handleCancel}
            className={`${styles.cancelButton}`}
            disabled={isDisconnecting}
          >
            Cancel
          </button>
          <button
            onClick={handleDisconnectAccounts}
            className={`${styles.disconnectButton} ${isDisconnecting ? styles.buttonLoading : ''}`}
            disabled={isDisconnecting}
          >
            {isDisconnecting ? (
              <>
                <div className={styles.spinner}></div>
                Disconnecting...
              </>
            ) : (
              'Disconnect'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Disconnect;
